<template>
  <div>
    <!-- Rights Management for User With Approval Flow - ALL PURCHASES - Expenses Flow -->
    <b-row v-if="showSection">
      <b-col md="12"><u><b>Rights Management for User With Approval Flow - ALL PURCHASES - Expenses Flow</b></u></b-col>
      <b-col md="3">
        <label>
          Shipment Type
          <span class="error" v-if="requireValidation">*</span>
        </label>
        <CustomMultiSelect 
          :options="shipmentTypeList" 
          :selected-options="shipmentType_items"
          v-model="localData.ape_shipment_type" 
          placeholder="Select Shipment Type" 
          :multiple="true"
          :error-class="getErrorClass('ape_shipment_type')"
          @select="SelectMultishipmentType">
        </CustomMultiSelect>
        <span class="error" v-if="requireValidation && validationTriggered && (!localData.ape_shipment_type || localData.ape_shipment_type.length === 0)">
          {{ errorMessages.ape_shipment_type }}
        </span>
      </b-col>
      <b-col md="3">
        <label>
          Module Type
          <span class="error" v-if="requireValidation">*</span>
        </label>
        <CustomMultiSelect 
          :options="moduelTypeList" 
          :selected-options="moduelType_items"
          v-model="localData.ape_moduel_type" 
          placeholder="Select Module Type" 
          :multiple="true"
          :error-class="getErrorClass('ape_moduel_type')"
          @select="SelectMultimoduelType">
        </CustomMultiSelect>
        <span class="error" v-if="requireValidation && validationTriggered && (!localData.ape_moduel_type || localData.ape_moduel_type.length === 0)">
          {{ errorMessages.ape_moduel_type }}
        </span>
      </b-col>
      <b-col md="3">
        <label>
          Job Type
          <span class="error" v-if="requireValidation">*</span>
        </label>
        <CustomMultiSelect 
          :options="jobTypeList" 
          :selected-options="jobType_items" 
          v-model="localData.ape_job_type"
          
          placeholder="Select Job Type" 
          :multiple="true" 
          :error-class="getErrorClass('ape_job_type')"
          @select="SelectMultijobType">
        </CustomMultiSelect>
        <span class="error" v-if="requireValidation && validationTriggered && (!localData.ape_job_type || localData.ape_job_type.length === 0)">
          {{ errorMessages.ape_job_type }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CustomMultiSelect from "./CustomMultiSelect.vue";

export default {
  name: "RightsManagementComponent",
  components: {
    CustomMultiSelect,
  },
  props: {
    userData: {
      type: Object,
      default: () => ({})
    },
    showSection: {
      type: Boolean,
      default: false
    },
    requireValidation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localData: {
        ape_shipment_type: [],
        ape_moduel_type: [],
        ape_job_type: [],
      },
      shipmentType_items: [],
      moduelType_items: [],
      jobType_items: [],
      validationTriggered: false, // Only show errors after validation is triggered
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea"
        },
        {
          text: "Air",
          value: "Air"
        }
      ],
      moduelTypeList: [
        {
          text: "Export",
          value: "Export"
        },
        {
          text: "Import",
          value: "Import"
        },
        {
          text: "Domestic",
          value: "Domestic"
        }
      ],
      jobTypeList: [
        {
          text: "FF",
          value: "FF"
        },
        {
          text: "CC",
          value: "CC"
        },
        {
          text: "TPT",
          value: "TPT"
        },
        {
          text: "MISC",
          value: "MISC"
        },
        {
          text: "YARD",
          value: "YARD"
        },
        {
          text: "IB",
          value: "IB"
        }
      ],
      errorMessages: {
        ape_shipment_type: "Select Shipment Type",
        ape_moduel_type: "Select Module Type",
        ape_job_type: "Select Job Type"
      }
    };
  },
  watch: {
    userData: {
      handler(newVal) {
        if (newVal) {
          this.loadUserData(newVal);
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    // Initialize data when component is mounted
    this.initializeData();
  },
  methods: {
    initializeData() {
      // Initialize with empty arrays if no data is provided
      if (!this.userData || Object.keys(this.userData).length === 0) {
        this.localData = {
          ape_shipment_type: [],
          ape_moduel_type: [],
          ape_job_type: [],
        };
        this.shipmentType_items = [];
        this.moduelType_items = [];
        this.jobType_items = [];
        // Emit initial empty data
        this.emitData();
      }
    },
    loadUserData(userData) {
      // Load shipment type data
      if (userData.ape_shipment_type && userData.ape_shipment_type.length > 0) {
        this.localData.ape_shipment_type = userData.ape_shipment_type;
        this.shipmentType_items = userData.ape_shipment_type;
      } else {
        this.localData.ape_shipment_type = [];
        this.shipmentType_items = [];
      }

      // Load module type data
      if (userData.ape_moduel_type && userData.ape_moduel_type.length > 0) {
        this.localData.ape_moduel_type = userData.ape_moduel_type;
        this.moduelType_items = userData.ape_moduel_type;
      } else {
        this.localData.ape_moduel_type = [];
        this.moduelType_items = [];
      }

      // Load job type data
      if (userData.ape_job_type && userData.ape_job_type.length > 0) {
        this.localData.ape_job_type = userData.ape_job_type;
        this.jobType_items = userData.ape_job_type;
      } else {
        this.localData.ape_job_type = [];
        this.jobType_items = [];
      }
    },
    SelectMultishipmentType(shipmentType_items, lastSelectItem) {
      this.shipmentType_items = shipmentType_items;
      this.localData.ape_shipment_type = shipmentType_items;
      this.emitData();
    },
    SelectMultimoduelType(moduelType_items, lastSelectItem) {
      this.moduelType_items = moduelType_items;
      this.localData.ape_moduel_type = moduelType_items;
      this.emitData();
    },
    SelectMultijobType(jobType_items, lastSelectItem) {
      this.jobType_items = jobType_items;
      this.localData.ape_job_type = jobType_items;
      this.emitData();
    },
    emitData() {
      this.$emit('rights-data-changed', {
        ape_shipment_type: this.localData.ape_shipment_type,
        ape_moduel_type: this.localData.ape_moduel_type,
        ape_job_type: this.localData.ape_job_type
      });
    },
    validateRightsData() {
      const errors = [];
      
      // Trigger validation flag to show errors
      this.validationTriggered = true;
      
      // Only validate if validation is required
      if (this.requireValidation) {
        if (!this.localData.ape_shipment_type || this.localData.ape_shipment_type.length === 0) {
          errors.push('ape_shipment_type');
        }
        if (!this.localData.ape_moduel_type || this.localData.ape_moduel_type.length === 0) {
          errors.push('ape_moduel_type');
        }
        if (!this.localData.ape_job_type || this.localData.ape_job_type.length === 0) {
          errors.push('ape_job_type');
        }
      }
      
      return errors;
    },
    triggerValidation() {
      // Method to manually trigger validation (called from parent)
      this.validationTriggered = true;
      return this.validateRightsData();
    },
    getRightsData() {
      return {
        ape_shipment_type: this.localData.ape_shipment_type,
        ape_moduel_type: this.localData.ape_moduel_type,
        ape_job_type: this.localData.ape_job_type
      };
    },
    getErrorClass(fieldName) {
      // Return error class if validation is triggered and field is empty
      if (this.requireValidation && this.validationTriggered) {
        if (fieldName === 'ape_shipment_type' && (!this.localData.ape_shipment_type || this.localData.ape_shipment_type.length === 0)) {
          return 'is-invalid';
        }
        if (fieldName === 'ape_moduel_type' && (!this.localData.ape_moduel_type || this.localData.ape_moduel_type.length === 0)) {
          return 'is-invalid';
        }
        if (fieldName === 'ape_job_type' && (!this.localData.ape_job_type || this.localData.ape_job_type.length === 0)) {
          return 'is-invalid';
        }
      }
      return '';
    },
  }
};
</script>

<style scoped>
.error {
  color: red;
}

/* Custom multi-select styling is handled by the CustomMultiSelect component */
</style>



// WEBPACK FOOTER //
// RightsManagementComponent.vue?41f744d6